import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { ProjectForm } from './components/ProjectForm';
import { AnalysisList } from './components/AnalysisList';
import { generateAnalysis } from './lib/api';
import { SWOTAnalysis } from './types';
import toast from 'react-hot-toast';

export function App() {
  const [projectDescription, setProjectDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [analyses, setAnalyses] = useState<SWOTAnalysis[]>([]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const trimmedDescription = projectDescription.trim();
    if (!trimmedDescription) {
      toast.error('الرجاء إدخال وصف المشروع');
      return;
    }

    if (trimmedDescription.length > 1000) {
      toast.error('وصف المشروع طويل جداً. الحد الأقصى هو 1000 حرف');
      return;
    }
    
    setLoading(true);
    const toastId = toast.loading('جاري تحليل المشروع...');

    try {
      const analysis = await generateAnalysis(trimmedDescription);
      
      const newAnalysis: SWOTAnalysis = {
        id: Date.now(),
        created_at: new Date().toISOString(),
        project_name: trimmedDescription,
        ...analysis,
        user_id: ''
      };

      setAnalyses(prev => [newAnalysis, ...prev]);
      toast.success('تم إنشاء التحليل بنجاح', { id: toastId });
      setProjectDescription('');
    } catch (error) {
      console.error('Submit Error:', error);
      toast.error(
        error instanceof Error ? error.message : 'حدث خطأ أثناء إنشاء التحليل',
        { id: toastId }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <ProjectForm
        projectDescription={projectDescription}
        setProjectDescription={setProjectDescription}
        onSubmit={handleSubmit}
        loading={loading}
      />
      <AnalysisList analyses={analyses} />
    </Layout>
  );
}

export default App;